import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isEmpty } from "lodash";
import { BUTTON_TYPE } from "prefab";
import { FORM_FIELD_TYPE } from "../../../../constants";
import RightPanel from "../../../common/RightPanel";
import Form from "../../../common/Form";
import BulkActionButtonsStyles from "../../../../styles/BulkActionButtons.module.scss";
import styles from "../../../../styles/Campaigns/PauseOrResumeActions.module.scss";

export default class CancelCampaigns extends Component {
  state = {
    fromDate: this.props.fromDate,
    hasError: false,
  };

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    cancelCampaigns: PropTypes.func.isRequired,
  };

  static defaultProps = {
    fromDate: null,
    selectionInfo: null,
  };

  componentWillUnmount = () => {
    this.cancelAction();
  };

  cancelAction = () => {
    this.setState({
      fromDate: null,
      hasError: false,
    });
    this.props.onClose();
  };

  save = () => {
    const { fromDate } = this.state;
    const data = moment(fromDate, "YYYY-MM-DD").isValid()
      ? { fromDate, clearCancellation: false }
      : {};
    //Validation to check if fromDate is entered
    if (!data?.fromDate) {
      this.setState({ hasError: true });
      return;
    }
    this.props.cancelCampaigns(data);
  };

  clear = () => {
    this.props.cancelCampaigns({ fromDate: "", clearCancellation: true });
  };

  render = () => {
    const { isOpen, header, selectionInfo, actionType, selected } = this.props;
    const { fromDate, hasError } = this.state;
    //!Date Range Validation
    //max date allowed to cancel - set to end of day for consistent comparison
    const maxDate = selected
      ? new Date(
          moment.min(selected?.map((campaign) => moment(campaign?.validity?.toDate).endOf("day")))
        )
      : undefined;
    //min date allowed to cancel - set to start of day
    let minDate = selected
      ? new Date(
          moment.max(
            selected?.map((campaign) => moment(campaign?.validity?.fromDate).startOf("day"))
          )
        )
      : undefined;
    // Compare with start of today
    const todayStart = moment().startOf("day").toDate();
    minDate = minDate > todayStart ? minDate : todayStart;

    return (
      <RightPanel
        isOpen={isOpen}
        onClose={() => this.cancelAction()}
        header={header}
        showFooter={true}
        primaryButtonProps={[
          {
            text: "Button.cancel",
            buttonType: BUTTON_TYPE.PRIMARY,
            onClick: this.save,
          },
          {
            text: "Button.clear",
            buttonType: BUTTON_TYPE.PRIMARY,
            onClick: this.clear,
            className: styles.clear,
          },
        ]}
        secondaryButtonProps={{ text: "Button.close", onClick: this.cancelAction }}
      >
        {!isEmpty(selectionInfo) && (
          <div className={BulkActionButtonsStyles.selectionInfoContainer}>
            <div className={BulkActionButtonsStyles.selectionInfo}>
              <span>{selectionInfo.count}</span> {selectionInfo.label} Selected
            </div>
          </div>
        )}
        <Form
          config={[
            {
              type: FORM_FIELD_TYPE.DATE,
              title: `${actionType} From`,
              invalidDateMessage: "Invalid From Date",
              onChange: (v) => {
                this.setState({ fromDate: moment(v).format("YYYY-MM-DDTHH:mm:ss[Z]") });
              },
              value: fromDate ? new Date(fromDate) : null,
              placeholder: "MM/DD/YYYY",
              minDate: minDate,
              error: hasError && !fromDate,
              errorMessage: "Enter Valid From Date",
              maxDate: maxDate,
              disabled: minDate > maxDate,
              defaultValue: minDate,
            },
          ]}
        />
        <div className={styles.campaignActionInfo}>
          <span>
            All schedules on the from day may not be cancelled entirely. Any applicable cancellation
            fees will be charged on cancellation
          </span>
        </div>
      </RightPanel>
    );
  };
}
